import { API_ROUTES } from '@config/routes';
import api from './api';

export interface ProjectCommandCenterMessage {
  id: string;
  type: 'agent' | 'vendor' | string;
  content: string;
  pendingActionId?: string | null;
  activityType?: string | null;
  createdAt: string;
}

export interface PendingEmailDraft {
  id: string;
  projectId: string;
  projectName: string;
  contactName: string;
  contactEmail: string;
  type: string;
  /** JSON string: { subject, content } */
  payload: string;
  analysis?: string;
  status: 'pending' | 'approved' | 'dismissed' | 'edited';
  created_at?: unknown;
  updated_at?: unknown;
}

export type PendingDraftResolution = 'approved' | 'dismissed' | 'edited' | 'updated';

export interface ResolvePendingDraftResult {
  id: string;
  status: string;
  emailSent?: boolean;
  emailSendError?: string | null;
  confirmationMessage?: string | null;
  edited_payload?: string;
}

export const orchestratorService = {
  getProjectMessages: async (projectId: string) =>
    api.get<ProjectCommandCenterMessage[]>(API_ROUTES.ORCHESTRATOR.PROJECT_MESSAGES(projectId)),

  listPendingEmailDrafts: async () =>
    api.get<PendingEmailDraft[]>(API_ROUTES.ORCHESTRATOR.PENDING_DRAFTS),

  resolvePendingAction: async (
    projectId: string,
    actionId: string,
    resolution: PendingDraftResolution,
    editedPayload?: string
  ) =>
    api.patch<ResolvePendingDraftResult>(
      API_ROUTES.ORCHESTRATOR.RESOLVE_PENDING(projectId, actionId),
      { resolution, editedPayload: editedPayload ?? null }
    ),
};
